import { OneOfElements } from '@shared/models/project.model';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type ElementDeactivateChange =
  ProjectChangeMap[ProjectChangeType.ElementDeactivate];

/**
 * Set {@link IElement.isDeactivated} to true for user-disabled elements.
 *
 * @param element - Current element state
 * @param change - Deactivate payload
 * @returns Partial element or undefined when not an {@link ElementKind.Element} or already deactivated
 */
export const elementDeactivateToChange = (
  element: OneOfElements,
  _change: ElementDeactivateChange,
): Partial<OneOfElements> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;
  if (element.isDeactivated === true) return undefined;

  return { isDeactivated: true };
};
